import MyGoogleMap from 'javascripts/modules/google-map';

class LocationMap {

	constructor(){
		this._init();
	}

	_init(){
		const args = {
			// streetViewControl: false,
			// panControl:        false,
			// scrollwheel:       false,
			// cluster:           false
		};
	  const map = new MyGoogleMap('location-map', args);
	}

}

export const locationMap = new LocationMap();